module.exports = __webpack_public_path__ + "img/second-day-10.6ea46a51.webp";